export const SESSION_TIMEOUT_MS = 15000;
export const PROFILE_LOAD_TIMEOUT_MS = 60000;
export const RPC_TIMEOUT_MS = 10000;

export async function runWithAbortTimeout<T>(
  label: string,
  run: (signal: AbortSignal) => PromiseLike<T>,
  timeoutMs: number
): Promise<T> {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  try {
    const timeoutPromise = new Promise<never>((_, reject) => {
      timeoutId = globalThis.setTimeout(() => {
        controller.abort();
        reject(new Error(`Timeout after ${timeoutMs}ms: ${label}`));
      }, timeoutMs);
    });

    // Use Promise.race to ensure we bail out if the timeout fires,
    // even if the underlying operation ignores the abort signal.
    return await Promise.race([
      run(controller.signal),
      timeoutPromise
    ]);
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}

export function maybeAttachAbortSignal<T>(query: T, signal: AbortSignal): T {
  const maybeWithAbort = query as unknown as { abortSignal?: (signal: AbortSignal) => T };
  if (typeof maybeWithAbort.abortSignal === 'function') {
    return maybeWithAbort.abortSignal(signal);
  }
  return query;
}
